#import "../fragments/template-fragment.graphql"

query GetTemplate($templateId: ID!) {
    template(id: $templateId) {
        ...TemplateFragment
    }
}
